export interface SplitFinding {
  headline: string;
  supporting?: string;
}

const ABBREVIATIONS = new Set(['vs', 'e.g', 'i.e', 'no', 'st', 'dr', 'approx', 'incl', 'avg']);

const BOUNDARY_RE = /[.!?]\s+/g;

export function splitFindingText(text: string): SplitFinding {
  const trimmed = text.trim();
  if (!trimmed) {
    return { headline: '' };
  }

  BOUNDARY_RE.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = BOUNDARY_RE.exec(trimmed)) !== null) {
    const boundaryEnd = match.index + 1;
    const before = trimmed.slice(0, match.index);
    const lastWord = (before.split(/[\s(]/).pop() ?? '').toLowerCase();
    if (ABBREVIATIONS.has(lastWord)) {
      continue;
    }

    const headline = trimmed.slice(0, boundaryEnd).trim();
    const supporting = trimmed.slice(boundaryEnd).trim();
    return supporting ? { headline, supporting } : { headline };
  }

  return { headline: trimmed };
}
